/**
 * Normaliza el valor de geocerca que llega a los reportes para el chip de estado.
 */
export function getGeofenceStatus(value) {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase()

  if (normalized === 'sí' || normalized === 'si') {
    return { label: 'Sí', variant: 'success' }
  }

  if (normalized === 'no') {
    return { label: 'No', variant: 'danger' }
  }

  return { label: 'N/A', variant: 'neutral' }
}
